import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'leimma2';
const args = {};

export class Leimma2 extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
